import { createTheme } from "@mui/material";
const CustomTheme = createTheme({
  typography: {
    fontFamily: ["Nunito"].join(","),
  },
});
export default CustomTheme;
